function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m79.67 0h-22.27a57 57 0 0 1 -23 46l-8.83 6.61 34.2 46.62h28.08l-31.46-42.92a78.93 78.93 0 0 0 23.28-56.31z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0h22.82v99.21h-22.82z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m94.49.02h21.5v99.16h-21.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m304.57 28.74c-8.2 0-16 2.55-21.15 9.58v-7.73h-20.42v68.59h20.7v-36.05c0-10.43 7-15.53 15.41-15.53 9 0 14.22 5.39 14.22 15.39v36.19h20.51v-43.62c-.03-15.96-12.72-26.82-29.27-26.82z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m181 30.59v4.41a36.2 36.2 0 1 0 0 59.83v4.38h20.53v-68.62zm-18.72 51.94c-10.28 0-18.61-7.9-18.61-17.64s8.33-17.65 18.61-17.65 18.61 7.9 18.61 17.65-8.33 17.64-18.61 17.64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m233.26 39.52v-8.93h-21v68.59h21.07v-32c0-10.81 11.71-16.62 19.84-16.62h.24v-20c-8.36.03-16.03 3.6-20.15 8.96z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m397.62 30.59v4.41a36.2 36.2 0 1 0 0 59.83v4.38h20.54v-68.62zm-18.68 51.94c-10.27 0-18.61-7.9-18.61-17.64s8.34-17.65 18.61-17.65 18.61 7.9 18.61 17.65-8.33 17.64-18.61 17.64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m433.07 34.1a1.5 1.5 0 0 0 .91-1.49 1.65 1.65 0 0 0 -1.82-1.61h-1.91v5.18h.92v-1.92h1l.84 1.92h1zm-.91-.68h-1v-1.58h1c.62 0 .89.31.89.77s-.18.81-.89.81z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m431.93 28.74a4.93 4.93 0 1 0 4.87 4.92 4.89 4.89 0 0 0 -4.87-4.92zm0 8.9a4 4 0 1 1 3.92-4 4 4 0 0 1 -3.92 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m440 74.85a12.89 12.89 0 1 0 12.89 12.89 12.89 12.89 0 0 0 -12.89-12.89z"
}));

var SvgKlarnaLogoWhite = function SvgKlarnaLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 452.85 101.08"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/KlarnaLogoWhite.8340547c.svg";
export { SvgKlarnaLogoWhite as ReactComponent };